import React, { useEffect, useState } from "react";
import { HolidayCalenderListType } from "../../../redux/masterData/masterTypes";
import { formatDate } from "../../../utils/commonFunctions";
import BoxLoader from "../../commons/BoxLoader/BoxLoader";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  data: HolidayCalenderListType[] | [];
  handleToggleHolidaysModal: () => void;
  fetching: boolean;
};

const LoggedInUsersHolidayCalendar = ({
  data,
  handleToggleHolidaysModal,
  fetching,
}: AppProps) => {
  return (
    <div className="p-3 boxs w-100" style={{ height: "100%" }}>
      {fetching ? (
        <BoxLoader style={{ height: "100%" }} />
      ) : (
        <>
          <div className="d-flex justify-content-between align-items-center">
            <div style={{ fontSize: "18px", fontWeight: 600 }}>
              Holiday Calendar
            </div>
            <button
              className="btn btn-outline"
              onClick={handleToggleHolidaysModal}
            >
              View All
            </button>
          </div>
          <div className="mt-4" 
          // style={{overflow:'auto', maxHeight:'281px'}}
          >
            {data?.length
              ? data?.map((el: HolidayCalenderListType) => {
                  return (
                    <div className="holiday-box-item">
                      <div className="d-flex align-items-center justify-content-flex-start" 
                      // style={{minWidth:'190px'}}
                      >
                        <div
                          style={{
                            width: "5px",
                            height: "100%",
                            backgroundColor: "#e7733e",
                          }}
                        ></div>
                        {el?.description&& el?.description?.length > 25 ?(

                      
                        <OverlayTrigger 
                          placement="bottom"
                          delay={{ show: 250, hide: 250 }}
                          overlay={
                            <Tooltip id="button-view-download-invoice">{el?.description}</Tooltip>
                          }
                        >

                        <div className="ml-2" >{el?.description.slice(0,25)} ...</div>
                        </OverlayTrigger>
                          ):(
                          <div className="ml-2">{el?.description}</div>
                        )}

                          
                      </div>
                      <div className="d-flex align-items-center mr-2" 
                      // style={{minWidth:'27%'}}
                      >
                        {formatDate(el?.date)}
                      </div>
                    </div>
                  );
                })
              : ""}
          </div>
        </>
      )}
    </div>
  );
};

export default LoggedInUsersHolidayCalendar;
